// removed by extract-text-webpack-plugin
module.exports = {"watermarkBackground":"VnosaD4PGnVTVlI9Iu9Gu","isWatermark":"oGyNYKCHyJGFnsM8f27hI","watermarkBackgroundMuted":"_3_iLsajhl9FKUN7TljNhFv","typeCell":"qOLwhJ4ycdE9_0bPLuJDG","irefCell":"_155Mxgg0XyTRm19a2Yqk_t","actionsCell":"_1Et8sFg26CLUXVQ5MY0lBY","actions":"_11lmigH02LrqtzeM04mDa4","actionsMenu":"_3XoK_CCcnYuVgS2Brh6GuW","moreContainer":"_2MFAJzfEut3p9-4A_CjGi7","moreIcon":"_3SnRpQf4S6RoKfZY6GV-Yn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/ProjectsListItem/ProjectsListItem.scss
// module id = 1299
// module chunks = 1